<div class="row">
    <a href="single.html" class="col-lg-6">
        <div class="con-sed-grid">

            <div class="elit-grid">
                <h4>consectetur elit</h4>
                <label>FOR ALL PURCHASE VALUE</label>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, </p>
                <span class="on-get">GET NOW</span>
            </div>
            <img class="img-responsive shoe-left" src="images/sh.jpg" alt=" " />

            <div class="clearfix"> </div>

        </div>
    </a>
    <a href="single.html" class="col-lg-6">
        <div class="con-sed-grid sed-left-top">
            <div class="elit-grid">
                <h4>consectetur elit</h4>
                <label>FOR ALL PURCHASE VALUE</label>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, </p>
                <span class="on-get">GET NOW</span>
            </div>
            <img class="img-responsive shoe-left" src="images/wa.jpg" alt=" " />

            <div class="clearfix"> </div>
        </div>
    </a>
</div>
<div *ngFor="let menu of menus">
    <input #myname style="display: none;" type="text" value={{menu.key}}>
    <div class="products">
        <h5 class="latest-product">{{menu.name}}</h5>
        <a class="view-all" [routerLink]="['/introduce', menu.key]">Xem tất cả<span> </span></a>
    </div>
    <div class="row">
        <div class="col-4" *ngFor="let subMenu of subMenus| slice:0:3; let i=index">
            <div class="item">
                <a [routerLink]="['/list-menu-product']" [queryParams]="{ id1: menu.key, id2: subMenu.key }"><img class="img-thumbnail img-responsive chain" [src]="subMenu.avatar | async" alt=" " /></a>
                <span class="star"> </span>
                <div class="grid-chain-bottom">
                    <h6><a [routerLink]="['/list-menu-product']" [queryParams]="{ id1: menu.key, id2: subMenu.key }">{{subMenu.name}}</a></h6>
                    <div class="star-price">
                        <div class="dolor-grid">
                            <span class="actual">300$</span>
                            <span class="reducedfrom">400$</span>

                        </div>
                        <a class="now-get get-cart" [routerLink]="['/list-menu-product']" [queryParams]="{ id1: menu.key, id2: subMenu.key }">Chi tiết</a>
                        <div class="clearfix"> </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="clearfix"> </div>
    </div>
</div>